(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Product rows: tabs, one sliding row, photos that wait. One copy for every row on the page (speed, 26 Oct; these
    // were three inline scripts in every section).
    var lazyImages = function (scope) {
      // New Arrivals cards 5+ and hidden tabs: load the photo when it is about to scroll into view (slow connections).
      var imgs = scope.querySelectorAll('img[data-src]');
      if (!imgs.length) return;
      var show = function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      };
      if (!('IntersectionObserver' in window)) return imgs.forEach(show);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '200px' });
      imgs.forEach(function (img) { io.observe(img); });
    };

    // Tabs whose cards are not in the page yet (data-pc-src): fetch them once.
    var loadPanel = function (root, panel) {
      if (!panel || !panel.dataset.pcSrc || panel.dataset.pcState) return;
      panel.dataset.pcState = 'loading';
      fetch(panel.dataset.pcSrc, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          panel.innerHTML = html;
          panel.dataset.pcState = 'done';
          panel.style.minHeight = '';
          lazyImages(panel);
          if (window.AnayaWishlist && window.AnayaWishlist.bind) window.AnayaWishlist.bind(panel);
          root.dispatchEvent(new CustomEvent('pc:tab'));
        })
        .catch(function () { delete panel.dataset.pcState; panel.style.minHeight = ''; });
    };

    var initTabs = function (root) {
      // Tabs (user, 25 Oct): one row, several collections. Photos in hidden tabs load when the tab opens.
      var list = root.querySelector('[data-pc-tabs]');
      if (!list) return;
      var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
      var links = root.querySelectorAll('[data-pc-link]');
      var panelOf = function (t) { return document.getElementById(t.getAttribute('aria-controls')); };
      var select = function (tab, focus) {
        var open = root.querySelector('[role="tabpanel"]:not([hidden])');
        var height = open ? open.offsetHeight : 0;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = panelOf(t);
          if (panel) panel.hidden = !on;
        });
        var panel = panelOf(tab);
        if (panel && panel.dataset.pcSrc && panel.dataset.pcState !== 'done') {
          // keep the row's height while the cards arrive, so the page doesn't jump
          panel.style.minHeight = height + 'px';
          loadPanel(root, panel);
        }
        if (tab.dataset.url) links.forEach(function (a) { a.href = tab.dataset.url; });
        root.dispatchEvent(new CustomEvent('pc:tab'));
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        // start loading as soon as the finger or mouse reaches the tab
        ['pointerenter', 'touchstart', 'focus'].forEach(function (type) {
          tab.addEventListener(type, function () { loadPanel(root, panelOf(tab)); }, { passive: true });
        });
        tab.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault();
          select(tabs[(n + tabs.length) % tabs.length], true);
        });
      });
      // the other tabs load once the page has finished and the browser is idle, one after another
      var later = function () {
        var queue = [].slice.call(root.querySelectorAll('[data-pc-src]'));
        var next = function () {
          var panel = queue.shift();
          if (!panel) return;
          if (panel.dataset.pcState) return next();
          loadPanel(root, panel);
          var wait = setInterval(function () {
            if (panel.dataset.pcState !== 'loading') { clearInterval(wait); next(); }
          }, 200);
        };
        (window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); })(next, { timeout: 4000 });
      };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    };

    var initRow = function (root) {
      // One sliding row (user, 25 Oct; like pk.saniamaskatiya.com): swipe on phones, trackpad or drag with the mouse
      // on desktop; the thin line under the row shows where you are.
      var bar = root.querySelector('[data-pc-progress] span');
      if (!bar) return;
      var active = function () { return root.querySelector('[data-pc-row]:not([hidden])'); };
      var update = function () {
        var row = active();
        if (!row) return;
        var max = row.scrollWidth - row.clientWidth;
        var share = row.scrollWidth ? row.clientWidth / row.scrollWidth : 1;
        bar.parentElement.hidden = max <= 1;
        bar.style.width = (share * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 - share) / share) * 100 : 0) + '%)';
      };
      root.querySelectorAll('[data-pc-row]').forEach(function (row) {
        row.addEventListener('scroll', update, { passive: true });
        var startX = 0, startLeft = 0, moved = false, down = false;
        row.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; moved = false; startX = e.clientX; startLeft = row.scrollLeft;
        });
        window.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 5) { moved = true; row.classList.add('is-dragging'); }
          if (moved) row.scrollLeft = startLeft - dx;
        });
        window.addEventListener('pointerup', function () {
          if (!down) return;
          down = false;
          setTimeout(function () { row.classList.remove('is-dragging'); }, 0);
        });
        // a drag is not a click on the card under the mouse
        row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        row.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });
      root.addEventListener('pc:tab', update);
      window.addEventListener('resize', update);
      // The first check can run before the cards are laid out: check again once they are, and when the row changes size
      window.addEventListener('load', update);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(update);
        root.querySelectorAll('[data-pc-row]').forEach(function (row) { ro.observe(row); });
      }
      update();
    };

    var init = function (root) {
      if (!root || root.dataset.pcReady) return;
      root.dataset.pcReady = 'true';
      initTabs(root);
      initRow(root);
      lazyImages(root);
    };
    document.querySelectorAll('[id^="ProductCarousel-"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[id^="ProductCarousel-"]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wba-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pop = document.querySelector('[data-wba-pop]');
    if (!pop) return;
    const KEY = 'wba-nl-popup';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
    const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
    const days = Number(pop.dataset.days) || 14;
    const delay = (Number(pop.dataset.delay) || 10) * 1000;
    const saved = read();
    // A posted customer form re-renders every signup form on the page; open only when this one was sent.
    const formId = pop.closest('form').id;
    const openNow = pop.hasAttribute('data-open-now') && (!location.hash || location.hash === '#' + formId);
    if (!openNow && saved && (saved.signedUp || Date.now() - saved.closed < days * 864e5)) return;

    let lastFocus = null;
    const card = pop.querySelector('.wba-pop__card');
    const focusables = () => [...card.querySelectorAll('button, input:not([type=hidden]), a[href]')].filter((el) => !el.disabled);
    const onKey = (e) => {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab') return;
      const f = focusables(); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    const open = () => {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(() => pop.classList.add('is-open'));
      document.addEventListener('keydown', onKey);
      // Focus the dialog itself: not the email field (phone keyboards) and not the close button (it would show its focus ring).
      card.focus({ preventScroll: true });
    };
    function close() {
      pop.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      write({ closed: Date.now(), signedUp: !!(read() || {}).signedUp });
      setTimeout(() => { pop.hidden = true; lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); }, 300);
    }
    pop.querySelectorAll('[data-wba-pop-close]').forEach((b) => b.addEventListener('click', close));
    pop.closest('form').addEventListener('submit', () => write({ closed: Date.now(), signedUp: true }));

    if (openNow) return open();

    // Wait for the delay, a first scroll on touch screens, and a closed cookie banner.
    const touch = window.matchMedia('(hover: none)').matches;
    let scrolled = !touch;
    if (touch) window.addEventListener('scroll', () => { scrolled = true; }, { once: true, passive: true });
    const bannerOpen = () => {
      const b = document.getElementById('shopify-pc__banner');
      // The banner is position: fixed, so offsetParent is always null; measure it instead.
      return !!(b && b.getBoundingClientRect().height > 0 && getComputedStyle(b).visibility !== 'hidden');
    };
    const otherDialogOpen = () => !!document.querySelector('.anaya-drawer[aria-hidden="false"], dialog[open]');
    setTimeout(function tryOpen() {
      if (!scrolled || bannerOpen() || otherDialogOpen() || document.hidden) return setTimeout(tryOpen, 1500);
      open();
    }, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wba-shop-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-wba-edit]').forEach((root) => {
      const slides = [...root.querySelectorAll('.wba-edit__slide')];
      const imgs = slides.map((s) => s.querySelector('img')).filter(Boolean);
      const links = [...root.querySelectorAll('.wba-edit__link')];
      const show = (i) => {
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.index === String(i)));
        links.forEach((a) => a.classList.toggle('is-active', a.dataset.index === String(i)));
      };
      links.forEach((a) => {
        a.addEventListener('mouseenter', () => show(a.dataset.index));
        a.addEventListener('focus', () => show(a.dataset.index));
      });
      // The large photo is only shown on wide screens; load the first one there, the rest once the section is near.
      if (imgs.length && window.matchMedia('(min-width: 990px)').matches) {
        imgs[0].loading = 'eager';
        const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { imgs.forEach((img) => { img.loading = 'eager'; }); io.disconnect(); }
        }, { rootMargin: '300px 0px' }) : null;
        io ? io.observe(root) : imgs.forEach((img) => { img.loading = 'eager'; });
      }
      show(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
